export default {"src":"/_next/static/media/safety-security.c9d5c0f3.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};